import { FormikProps } from 'formik';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { IPolicyValues } from '../../../views/AddEditPolicy';

interface IDateAndMountPickerProps {
    context: FormikProps<IPolicyValues>;
}

export const DateAndMountPicker = ({ context }: IDateAndMountPickerProps) => {
    const [day, setDay] = useState('');
    const [mount, setMount] = useState(1);

    const { setFieldValue } = context;

    const handleDayArrowEvent = (purpose: string) => {
        if (day === '') {
            setDay(purpose === 'increment' ? '1' : '31');
        } else {
            const currentDay = parseInt(day);
            let newDay;

            if (purpose === 'increment') {
                newDay = (currentDay % 31) + 1;
            } else {
                newDay = currentDay === 1 ? 31 : currentDay - 1;
            }
            setDay(newDay.toString());
            setFieldValue('carriedOverValidToDay', newDay);
        }
    };

    const handleMonthArrowEvent = (purpose: string) => {
        if (purpose === 'increment') {
            const newMount = (mount % 12) + 1;
            setMount(newMount);
            setFieldValue('carriedOverValidToMonth', newMount);
        } else {
            const newMount = mount === 1 ? 12 : mount - 1;
            setMount(newMount);
            setFieldValue('carriedOverValidToMonth', newMount);
        }
    };

    const handleDayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedDay = event.target.value;
        if (updatedDay.length <= 2) {
            if (updatedDay === '' || /^\d+$/.test(updatedDay)) {
                setDay(updatedDay);
                setFieldValue('carriedOverValidToDay', updatedDay);
            }
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{ width: '24%' }} className="input-date-picker__date-field field-day">
                <input className="input-date-picker__date-field-input-day" value={context.values.carriedOverValidToDay} onChange={handleDayChange} />
                <div className="arrows">
                    <img
                        src="/img/arrow-down.svg"
                        className="arrow-up"
                        style={{ rotate: '180deg' }}
                        alt=""
                        onClick={() => handleDayArrowEvent('increment')}
                        onKeyDown={() => handleDayArrowEvent('increment')}
                    />
                    <img
                        src="/img/arrow-down.svg"
                        className="arrow-down"
                        alt=""
                        onClick={() => handleDayArrowEvent('decrement')}
                        onKeyDown={() => handleDayArrowEvent('decrement')}
                    />
                </div>
            </div>
            <div style={{ width: '74%' }} className="input-date-picker__date-field field-month">
                {DateTime.fromObject({ month: context.values.carriedOverValidToMonth }).toLocaleString({ month: 'long' })}

                <div className="arrows">
                    <img
                        src="/img/arrow-down.svg"
                        className="arrow-up"
                        style={{ rotate: '180deg' }}
                        alt=""
                        onClick={() => handleMonthArrowEvent('increment')}
                        onKeyDown={() => handleMonthArrowEvent('increment')}
                    />
                    <img
                        src="/img/arrow-down.svg"
                        className="arrow-down"
                        alt=""
                        onClick={() => handleMonthArrowEvent('decrement')}
                        onKeyDown={() => handleMonthArrowEvent('decrement')}
                    />
                </div>
            </div>
        </div>
    );
};
